var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKapital4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finally catch up on fixed costs",
    clipPath: "url(#clip0_437_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64 0H0V10.8856H4.096V46.2803H29.9631V50.3763L18.9885 59.8817H15.6717V63.9777H20.5245L29.9854 55.7857V59.8817H27.9374V63.9777H36.1071V59.8817H34.0591V55.7857L43.52 63.9777H48.3729V59.8817H45.056L34.0814 50.3763V46.2803H59.9485V10.8856H64.0445V0H64ZM55.8303 42.2066H8.16974V10.8856H55.8303V42.2066ZM59.9263 6.81183H4.096V4.096H59.9263V6.81183Z",
    fill: "#6135FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9811 37.4428H19.0771V33.8143C21.0361 33.2133 22.483 31.4324 22.483 29.2731C22.483 26.6463 20.346 24.5093 17.7192 24.5093H16.3613C15.9828 24.5093 15.6712 24.1976 15.6712 23.8192C15.6712 23.4408 15.9828 23.1291 16.3613 23.1291H22.483V19.0331H19.0771V15.6272H14.9811V19.2557C13.0222 19.8568 11.5752 21.6376 11.5752 23.7969C11.5752 26.4237 13.7122 28.5608 16.339 28.5608H17.6969C18.0754 28.5608 18.387 28.8724 18.387 29.2509C18.387 29.6293 18.0754 29.9409 17.6969 29.9409H11.5752V34.0369H14.9811V37.4428Z",
    fill: "#6135FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.1145 35.3947H51.0665V13.6235H46.9705V35.3947H44.6999V24.5091H40.6261V35.3947H38.3555V19.0552H34.2595V35.3947H32.0112V29.963H27.9152V35.3947H25.8672V39.4907H53.1145V35.3947Z",
    fill: "#6135FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKapital4);
export default __webpack_public_path__ + "static/media/kapital4.3464a4209511afcfe73b4e71280fa987.svg";
export { ForwardRef as ReactComponent };